export default (props, vars) => () =>
  document
    .getElementById('offer-letter-main')
    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
